// extracted by css-extract-rspack-plugin
export default {"complaintReasonFieldWrapper":"complaint-reason-field-wrapper--M_LKaZJQZIsu_1jo"};